export const InvestorChannels = {
	Core: 'core',
};
